import { CurrencyFiatResult, DataResponse } from '@block-explorer/entities';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const getAvailableCurrencyListAsync = createAsyncAction(
  'GET_AVAILABLE_CURRENCY_LIST_REQUEST',
  'GET_AVAILABLE_CURRENCY_LIST_SUCCESS',
  'GET_AVAILABLE_CURRENCY_LIST_FAILURE'
)<
  Record<string, never>,
  DataResponse<CurrencyFiatResult[]>,
  DataResponse<CurrencyFiatResult[]>
>();

export const setSelectedCurrency = createAction(
  'SET_SELECTED_CURRENCY'
)<CurrencyFiatResult>();
